<template>
  <div>
    <b-modal :id="`bv-modal-reviews`" size="xl" hide-footer>
      <template #modal-title>{{title}}</template>
        <div v-if="loading" class="text-center py-2"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="!reviews.success" class="text-center py-2">{{reviews.message}}</div>
        <div v-else>
          <div class="row">
            <div class="col-md-4">
              <review-block :reviews="reviews"></review-block>
            </div>
            <div class="col-md-8 pb-3">
              <review-list :product_id="product_id"></review-list>
            </div>
          </div>
        </div>
    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from '../bus';
export default {
  props: ['product_id'],

  data() {
    return {
      reviews: [],
      loading: false,
      title: 'Reviews',
    };
  },

  created() {
    this.getReviews();

    EventBus.$on('update-reviews', (stars) => {
            this.changeTitle(stars);
        });

    EventBus.$on('reset-reviews', () => {
            this.changeTitle();
        });
  },

  methods: {

    changeTitle(stars = null) {
      this.title = stars ? `${stars} star reviews` : 'Reviews';
    },

    getReviews(stars = null) {

      this.loading = true;

      axios.post(`/reviews/${this.product_id}`, { stars: stars }).
      then((response) => {
        this.reviews = response.data;
        this.loading = false;
      });

    },

    sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
      })

    },

  },
};
</script>